import { combineReducers } from 'redux';
import { fileReducer } from './fileReducer';
import { sendOtpReducer } from './sendOtpReduser';
import { checkOtpReducer } from './checkOtpReducer';
import { mainReducer } from './mainReducer';
import { connectRouter } from 'connected-react-router';

export const rootReducer = (history) =>
	combineReducers({
		router: connectRouter(history),
		mainState: mainReducer,
		checkOtpState: checkOtpReducer,
		sendOtpState: sendOtpReducer,
		sendFileState: fileReducer,
	});
